'use client'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import React from 'react'

import {
  getBugsnagAppVersion,
  getBugsnagEnabledReleaseStages,
  getBugsnagReleaseStage,
  shouldSendLocalBugsnagEvent,
} from './bugsnagConfig'

declare global {
  interface Window {
    __bugsnagStarted__?: boolean
  }
}

/**
 * Initialise Bugsnag une seule fois côté client,
 * puis renvoie le client. Retourne null si non configuré.
 */
export function getBugsnag() {
  if (typeof window === 'undefined') return null

  const apiKey = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY
  const releaseStage = getBugsnagReleaseStage()
  const appVersion = getBugsnagAppVersion()

  if (!apiKey) return null

  const appOrigin = window.location.origin

  if (!window.__bugsnagStarted__ && !Bugsnag.isStarted()) {
    Bugsnag.start({
      apiKey,
      releaseStage,
      appVersion,
      plugins: [new BugsnagPluginReact(React)],
      enabledReleaseStages: getBugsnagEnabledReleaseStages(),
      ...(releaseStage === 'development' ? { autoTrackSessions: false } : {}),
      onError: (event) => shouldSendLocalBugsnagEvent(event),
      enabledBreadcrumbTypes: ['error', 'navigation', 'request'],
      collectUserIp: false,
      redactedKeys: ['authorization', 'x-api-key', 'x-amz-security-token'],
      endpoints: {
        notify: `${appOrigin}/api/errors/notify`,
        sessions: `${appOrigin}/api/errors/sessions`,
      },
    })
    window.__bugsnagStarted__ = true
  }

  return Bugsnag
}
